<div class="payment-terms">
    <div class="title-heading text-center">{{ msg }}</div>
    
</div>  



